import React from 'react';

import { QueryClient, QueryClientProvider } from 'react-query';

import { CollectiveFilterProvider } from './CollectiveFilterContext';
import { ToastProvider } from './toastContext';
import SmartReloadWrapper from 'components/SmartReloadWrapper';
import { CandidateDiagnosticFilterProvider } from 'global/CandidateDiagnosticFilterContext';
import { DiagnosisFilterProvider } from 'global/DiagnosisFilterContext';
import { DrawerProvider } from 'global/DrawerContext';
import { EditStatusProvider } from 'global/EditStatusContext';
import { HorizontalSubmenuProvider } from 'global/HorizontalMenuContext';
import { MenuProvider } from 'global/MenuContext';
import { MenuSelectionProvider } from 'global/MenuSelectionContext';
import { ModalProvider } from 'global/ModalContext';
import { ReportProvider } from 'global/ReportContext';
import { SupportProvider } from 'global/SupportContext';
import { TabProvider } from 'global/TabContext';
import { TrajectoryActivitiesProvider } from 'global/TrajectoryActivitiesContext';
import { TrajectoryDonationsProvider } from 'global/TrajectoryDonationsContext';
import { TrajectoryExpensesProvider } from 'global/TrajectoryExpensesContext';
import { TrajectoryTimeLineProvider } from 'global/TrajectoryTimeLineContext';
import { TrajectoryValidVotesProvider } from 'global/TrajectoryValidVotesContext';
import { UserPersonProvider } from 'global/UsePersonContext';
import { UserProvider } from 'global/UserContext';
import { WebSocketProvider } from 'global/WebSocketContext';
import { FilterGlobalProvider } from 'hooks/useFilterGlobal';
import { FilterVoxProvider } from 'hooks/useFilterVox';
import { MenuTitleProvider } from 'hooks/useMenuTitleContext';
import { SidebarProvider } from 'hooks/useSideBar';
import { IChildTypes } from 'types/childrenTypes';

const queryClient = new QueryClient();

const ProviderContext: React.FC<IChildTypes> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <UserProvider>
          <WebSocketProvider>
            <MenuProvider>
              <MenuSelectionProvider>
                <SupportProvider>
                  <MenuTitleProvider>
                    <SidebarProvider>
                      <TabProvider>
                        <UserPersonProvider>
                          <EditStatusProvider>
                            <ModalProvider>
                              <ReportProvider>
                                <CandidateDiagnosticFilterProvider>
                                  <DiagnosisFilterProvider>
                                    <DrawerProvider>
                                      <FilterVoxProvider>
                                        <FilterGlobalProvider>
                                          <TrajectoryTimeLineProvider>
                                            <TrajectoryValidVotesProvider>
                                              <TrajectoryActivitiesProvider>
                                                <TrajectoryExpensesProvider>
                                                  <TrajectoryDonationsProvider>
                                                    <HorizontalSubmenuProvider>
                                                      <CollectiveFilterProvider>
                                                        <SmartReloadWrapper>
                                                          {children}
                                                        </SmartReloadWrapper>
                                                      </CollectiveFilterProvider>
                                                    </HorizontalSubmenuProvider>
                                                  </TrajectoryDonationsProvider>
                                                </TrajectoryExpensesProvider>
                                              </TrajectoryActivitiesProvider>
                                            </TrajectoryValidVotesProvider>
                                          </TrajectoryTimeLineProvider>
                                        </FilterGlobalProvider>
                                      </FilterVoxProvider>
                                    </DrawerProvider>
                                  </DiagnosisFilterProvider>
                                </CandidateDiagnosticFilterProvider>
                              </ReportProvider>
                            </ModalProvider>
                          </EditStatusProvider>
                        </UserPersonProvider>
                      </TabProvider>
                    </SidebarProvider>
                  </MenuTitleProvider>
                </SupportProvider>
              </MenuSelectionProvider>
            </MenuProvider>
          </WebSocketProvider>
        </UserProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
};

export default ProviderContext;
